
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-width":"1.5","d":"M7.733 20.553L19.415 8.871a2 2 0 000-2.828l-1.457-1.457a1.999 1.999 0 00-2.83 0L3.448 16.267a2.008 2.008 0 00-.526.93l-.89 3.56a1 1 0 001.213 1.212l3.56-.89a2 2 0 00.929-.526z"}})])
          )
        }
      }
    